import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "motion/react";
import type { LucideIcon } from "lucide-react";
import type { ShopifyCollection } from "@/lib/shopify";

interface SearchCategoriesResultsProps {
  collections: ShopifyCollection[];
  textAlign: string;
  ChevronDir: LucideIcon;
  onItemClick: () => void;
  t: (key: string, fallback: string) => string;
}

/** Pill list of Shopify collections matching the current query. */
export const SearchCategoriesResults = ({
  collections,
  textAlign,
  ChevronDir,
  onItemClick,
  t,
}: SearchCategoriesResultsProps) => {
  return (
    <div className="mb-4 sm:mb-6">
      <h3 className={`text-sm font-medium text-muted-foreground mb-2 sm:mb-3 ${textAlign}`}>
        {t("categories", "קטגוריות")}
      </h3>
      <div className="flex flex-wrap gap-2">
        <AnimatePresence mode="popLayout">
          {collections.slice(0, 6).map((collection, index) => (
            <motion.div
              key={collection.node.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.15, delay: index * 0.02 }}
            >
              <Link
                to={`/collections/${collection.node.handle}`}
                onClick={onItemClick}
                className="group flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border border-border/50 bg-background hover:border-primary/50 hover:bg-primary/5 transition-all duration-200"
              >
                {collection.node.image && (
                  <img
                    src={collection.node.image.url}
                    alt={collection.node.title}
                    loading="lazy"
                    className="w-5 h-5 sm:w-6 sm:h-6 rounded-full object-cover"
                  />
                )}
                <span className="text-xs sm:text-sm group-hover:text-primary transition-colors">
                  {collection.node.title}
                </span>
                <ChevronDir className="h-3 w-3 sm:h-4 sm:w-4 text-muted-foreground group-hover:text-primary transition-colors" />
              </Link>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};
